module.exports = __webpack_public_path__ + "img/logo2.01cd6ebd.png";